import React, { useEffect, useState } from 'react';
import Hombre from '../../assets/img/hombre.jpg';
import Mujer from '../../assets/img/mujer.jpg';
import NoDisponible from '../../assets/img/nodisponible.jpg';
import Spin from '../ui/Spin';
import {/*Icon,*/ TwitterOutlined, InstagramOutlined, YoutubeOutlined, FacebookOutlined, CheckCircleOutlined, DownloadOutlined, GlobalOutlined } from '@ant-design/icons';
import { Card, /*Space,*/ Avatar, Row, Col, Button, Image } from 'antd';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import Tipo1 from '../../assets/img/tipo1.png';
import Tipo4 from '../../assets/img/Logo-VI-UNAM-365x95-1.png';
import Tipo5 from '../../assets/img/tipo5.png';
import Tipo6 from '../../assets/img/tipo6.png';
import Tipo7 from '../../assets/img/tipo7.png';
import imgLaptop from '../../assets/img/laptop.png';
import tiktok from '../../assets/img/redesSociales/tikTok.png';
import xlogo from '../../assets/img/redesSociales/twitter-x.png';
import logoFacebook from '../../assets/img/redesSociales/face.png';
import logoIntagram from '../../assets/img/redesSociales/insta.png';
import logoYoutube from '../../assets/img/redesSociales/youtube.png';
import logoOtraRed from '../../assets/img/redesSociales/web.png';
import useBusquedaContext from '../../context/useBusquedaContext';
import { FaSearch, FaRegCheckCircle } from "react-icons/fa";

import useDataContext from '../../context/useDataContext';
import PdfViewerModal from './PdfViewerModal';

import "../../index.css";

let descripcionAccionAfirmativa = '';
const DetalleCandidato = (props) => {
	//console.log("PROPS detalle", props);

	const {
		tiposCandidaturas,
		setTiposCandidaturas,
		entidades,
		gradosAcademicos,
		generos,
		actoresPoliticos,
		candidatosDMR,
		candidatosDRP,
		candidatosSMR,
		candidatosSRP,
		candidatosPresidente,
		candidatosGubernatura,
		candidatosPresidenteMunicipal,
		hipervinculosDMR,
		hipervinculosDRP,
		hipervinculosGubernatura,
		hipervinculosPresidenteMunicipal,
		hipervinculosSMR,
		hipervinculosSRP,
		hipervinculosPresidente,
		redesSocialesDMR,
		redesSocialesDRP,
		redesSocialesGubernatura,
		redesSocialesSMR,
		redesSocialesPresidenteMunicipal,
		redesSocialesSRP,
		redesSocialesPresidente,
		cursosCandidatosDMR,
		cursosCandidatosDRP,
		cursosCandidatosGubernatura,
		cursosCandidatosPresidenteMunicipal,
		cursosCandidatosSMR,
		cursosCandidatosSRP,
		cursosCandidatosPresidente,
		regresar,
		setRegresar,
		actoresPoliticosPresidenteMunicipal,
		setActoresPoliticosPresidenteMunicipal,
		actoresPoliticosGubernatura,
		setActoresPoliticosGubernatura,
		actoresPoliticosDMR,
		setActoresPoliticosDMR,
		actoresPoliticosDRP,
		setActoresPoliticosDRP,
		actoresPoliticosSMR,
		setActoresPoliticosSMR,
		actoresPoliticosSRP,
		setActoresPoliticosSRP,
		actoresPoliticosPresidente,
		setActoresPoliticosPresidente,
		accionesAfirmativas,

		ministroSupremaCorte,
		candidatosSupremaCorte,
		redesSocialesSupremaCorte,
		cursosCandidatosSupremaCorte,
		hipervinculosSupremaCorte,
		magistradoTribDJ,
		candidatosTribunalDisciplina,
		redesSocialesTribunalDisciplina,
		cursosCandidatosTribunalDisciplina,
		hipervinculosTribunalDisciplina,
		magistradoSalaSup,
		candidatosSalaSuperior,
		redesSocialesSalaSuperior,
		cursosCandidatosSalaSuperior,
		hipervinculosSalaSuperior,
		juecesDistrito,
		candidatosJueces,
		redesSocialesJueces,
		cursosCandidatosJueces,
		hipervinculosJueces,
		magistradoTrib,
		candidatosCircuito,
		redesSocialesCircuito,
		cursosCandidatosCircuito,
		hipervinculosCircuito,
		magistradoSalaReg,
		candidatosSalaRegional,
		redesSocialesSalaRegional,
		cursosCandidatosSalaRegional,
		hipervinculosSalaRegional,

	} = useDataContext();

	const imagPoderUnion = {
		1: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PE.png`,
		2: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PL.png`,
		3: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PJ.png`,
		4: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/EF.png`,
	};

	const labelPoderes = {
		1: `${process.env.REACT_APP_ETIQUETA_PE}`,
		2: `${process.env.REACT_APP_ETIQUETA_PL}`,
		3: `${process.env.REACT_APP_ETIQUETA_PJ}`,
		4: `${process.env.REACT_APP_ETIQUETA_EF}`
	}

	let poderesficha;
	const [poderesfichaDos, setPoderesfichaDos] = useState();

	//console.log("Regresar2", regresar);
	const [candidato, setCandidato] = useState();
	const [redesSocialesCandidato, setRedesSocialesCandidato] = useState(null);
	const [hipervinculosCandidato, setHipervinculosCandidato] = useState(null);
	const [cursosCandidato, setCursosCandidato] = useState(null);
	const [srcFoto, setSrcFoto] = useState();
	const [srcEmblema, setSrcEmblema] = useState();
	const [srcImgPoder1, setSrcImgPoder1] = useState();
	const [srcImgPoder2, setSrcImgPoder2] = useState();
	const [srcImgPoder3, setSrcImgPoder3] = useState();
	const [srcImgPoder4, setSrcImgPoder4] = useState();
	const [propietarioSuplente, setpropietarioSuplente] = useState();
	const [nombreAsociacion, setNombreAsociacion] = useState();
	const [nombreEstadoCamp, setNombreEstadoCamp] = useState(null);
	const [nombreEstadoCand, setNombreEstadCand] = useState(null);
	const [grado, setGrado] = useState(null);
	const [buscar, setBuscar] = useState({
		//Hook para almacenar la información de la búsqueda
		infoBuscar: null,
	});

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [pdfUrl, setPdfUrl] = useState(null);

	const openModal = (event, idCandidato) => {
		event.preventDefault();
		const timestamp = new Date().getTime(); // Obtiene el tiempo actual en milisegundos
		setPdfUrl(
			`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_RUTA_PDF_CV}${candidato.idCandidato}.pdf?timestamp=${timestamp}`
		);
		setIsModalOpen(true);
	};


	let { idCandidato, idTipoCandidatura } = useParams();

	const [idCandidatoB, setIdCandidatoB] = useState(
		props.location.state && props.location.state.idCandidato ? props.location.state.idCandidato : idCandidato ? parseInt(idCandidato) : 0,
	);
	const [idTipoCandidaturaB, setIdTipoCandidaturaB] = useState(
		props.location.state && props.location.state.idTipoCandidatura
			? props.location.state.idTipoCandidatura
			: idTipoCandidatura
				? parseInt(idTipoCandidatura)
				: 0,
	);

	const fechaActual = new Date();
	const dia = fechaActual.getDate();
	const anio = fechaActual.getFullYear();
	const mes = fechaActual.getMonth();
	let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

	useEffect(() => { }, []);

	// -------------------- Ini codigo Leonardo ----------------------------
	// -------------------- datos candidato ----------------------------
	useEffect(() => {
		if (!candidatosSupremaCorte || candidatosSupremaCorte.length === 0) return;
		if (idTipoCandidaturaB === 6) {
			let candidato = candidatosSupremaCorte.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [ministroSupremaCorte, candidatosSupremaCorte]);

	useEffect(() => {
		if (!candidatosSalaSuperior || candidatosSalaSuperior.length === 0) return;
		if (idTipoCandidaturaB === 8) {
			let candidato = candidatosSalaSuperior.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [magistradoSalaSup, candidatosSalaSuperior]);

	useEffect(() => {
		if (!candidatosTribunalDisciplina || candidatosTribunalDisciplina.length === 0) return;
		if (idTipoCandidaturaB === 7) {
			let candidato = candidatosTribunalDisciplina.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [magistradoTribDJ, candidatosTribunalDisciplina]);

	useEffect(() => {
		if (!candidatosSalaRegional || candidatosSalaRegional.length === 0) return;
		if (idTipoCandidaturaB === 9) {
			let candidato = candidatosSalaRegional.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [magistradoSalaReg, candidatosSalaRegional]);

	useEffect(() => {
		if (!candidatosCircuito || candidatosCircuito.length === 0) return;
		if (idTipoCandidaturaB === 10) {
			let candidato = candidatosCircuito.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [magistradoTrib, candidatosCircuito]);


	useEffect(() => {
		if (!candidatosJueces || candidatosJueces.length === 0) return;

		if (idTipoCandidaturaB === 11) {
			let candidato = candidatosJueces.find((candidato) => candidato.idCandidato == idCandidatoB);
			setCandidato(candidato ? candidato : undefined);
		}
	}, [juecesDistrito, candidatosJueces]);

	// -------------------- hipervinculos ----------------------------
	useEffect(() => {
		if (hipervinculosSupremaCorte && idTipoCandidaturaB === 6) {
			let hipervinculosCandidato = hipervinculosSupremaCorte.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosSupremaCorte]);

	useEffect(() => {
		if (hipervinculosSalaSuperior && idTipoCandidaturaB === 8) {
			let hipervinculosCandidato = hipervinculosSalaSuperior.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosSalaSuperior]);

	useEffect(() => {
		if (hipervinculosTribunalDisciplina && idTipoCandidaturaB === 7) {
			let hipervinculosCandidato = hipervinculosTribunalDisciplina.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosTribunalDisciplina]);

	useEffect(() => {
		if (hipervinculosSalaRegional && idTipoCandidaturaB === 9) {
			let hipervinculosCandidato = hipervinculosSalaRegional.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosSalaRegional]);

	useEffect(() => {
		if (hipervinculosCircuito && idTipoCandidaturaB === 10) {
			let hipervinculosCandidato = hipervinculosCircuito.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosCircuito]);

	useEffect(() => {
		if (hipervinculosJueces && idTipoCandidaturaB === 11) {
			let hipervinculosCandidato = hipervinculosJueces.filter((hipervinculo) => hipervinculo.idCandidato === idCandidatoB);
			if (hipervinculosCandidato) setHipervinculosCandidato([...hipervinculosCandidato]);
		}
	}, [hipervinculosJueces]);

	// -------------------- redes sociales ----------------------------
	useEffect(() => {
		if (redesSocialesSupremaCorte && idTipoCandidaturaB === 6) {
			let redesSocialesCandidato = redesSocialesSupremaCorte.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesSupremaCorte]);

	useEffect(() => {
		if (redesSocialesSalaSuperior && idTipoCandidaturaB === 8) {
			let redesSocialesCandidato = redesSocialesSalaSuperior.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesSalaSuperior]);

	useEffect(() => {
		if (redesSocialesTribunalDisciplina && idTipoCandidaturaB === 7) {
			let redesSocialesCandidato = redesSocialesTribunalDisciplina.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesTribunalDisciplina]);

	useEffect(() => {
		if (redesSocialesSalaRegional && idTipoCandidaturaB === 9) {
			let redesSocialesCandidato = redesSocialesSalaRegional.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesSalaRegional]);

	useEffect(() => {
		if (redesSocialesCircuito && idTipoCandidaturaB === 10) {
			let redesSocialesCandidato = redesSocialesCircuito.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesCircuito]);

	useEffect(() => {
		if (redesSocialesJueces && idTipoCandidaturaB === 11) {
			let redesSocialesCandidato = redesSocialesJueces.filter((redSocial) => redSocial.idCandidato === idCandidatoB)
				.sort((a, b) => a.idTipoRed - b.idTipoRed);
			if (redesSocialesCandidato) setRedesSocialesCandidato([...redesSocialesCandidato]);
		}
	}, [redesSocialesJueces]);

	useEffect(() => {
		if (candidato !== undefined && candidato.poderPostula !== undefined) {
			if (candidato.poderPostula.map(poder => poder == 1)) {
				var url_image1 = `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PE.png`;
				setSrcImgPoder1(url_image1);
			}
			if (candidato.poderPostula.map(poder => poder == 2)) {
				var url_image2 = `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PL.png`;
				setSrcImgPoder2(url_image2);
			}
			if (candidato.poderPostula.map(poder => poder == 3)) {
				var url_image3 = `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PJ.png`;
				setSrcImgPoder3(url_image3);
			}
			if (candidato.poderPostula.map(poder => poder == 4)) {
				var url_image4 = `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/EF.png`;
				setSrcImgPoder4(url_image4);
			}
		}
	}, [candidato]);

	useEffect(() => {
		// if (candidato && candidato.urlFoto && candidato.estatusVal) {
		if (candidato && candidato.urlFoto) {
			//var url_image = `${process.env.REACT_APP_API_URL}img/fotocandidato/${candidato.idCandidato}.jpg`;
			var urlTmp = candidato.urlFoto.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_IMAGENES}`, '');
			var url_image = `${process.env.REACT_APP_API_URL}${urlTmp}`;
			setSrcFoto(url_image);
		} else if (candidato) {
			if (candidato.sexo == 'M') setSrcFoto(Mujer);
			else setSrcFoto(Hombre);
		}
		if (candidato && candidato.idGrado) {
			let grado = gradosAcademicos.find((ga) => ga.idGrado === candidato.idGrado);
			////console.log("gradoAcademico:=>", gradoAcademico);
			if (grado) setGrado(grado);
		}

		if (candidato &&  Array.isArray(candidato.poderPostula) && candidato.poderPostula.length > 0) {
			// Mapeamos los valores para mostrar las imágenes
				poderesficha = candidato.poderPostula.map((valor) => (
				<div className='divPoderPostula' key={valor} style={{ display: 'inline-block', marginRight: '10px' }}>
				<Image
					width={25}
					preview={false}
					src={imagPoderUnion[valor] || NoDisponible} // Usamos una imagen por defecto si no existe
					alt={labelPoderes[valor] || 'Poder no disponible'}
					onError={(e) => { e.target.src = NoDisponible }} // Imagen de reserva en caso de error
					style={{ marginTop: '-5px' }}
				/>
				<span style={{paddingLeft:"10px", fontSize: "10px"}}>
					{labelPoderes[valor] || 'Poder no disponible'}
				</span>
				</div>
			));

			setPoderesfichaDos(poderesficha);

			} else {
				// Si no hay poderes, mostramos un mensaje
				poderesficha = <span>La candidatura no proporcionó información.</span>;
				setPoderesfichaDos(<span>La candidatura no proporcionó información.</span>);
			}

	}, [candidato]);

	useEffect(() => {
		if (candidato && candidato.idGrado) {
			let grado = gradosAcademicos.find((ga) => ga.idGrado === candidato.idGrado);
			////console.log("gradoAcademico:=>", gradoAcademico);
			if (grado) setGrado(grado);
		}
	}, [candidato, gradosAcademicos]);

	useEffect(() => {
		if (candidato) {
			//console.log("CANDIDATO ESTADO", candidato);
			if (candidato.idEstadoEleccion) {
				let entidadEleccion = entidades.find((entidad) => entidad.idEstado === candidato.idEstadoEleccion);

				if (entidadEleccion) {
					//console.log("CANDIDATO ESTADO1", candidato)

					setNombreEstadCand(entidadEleccion.nombreEstado);
					//console.log("CANDIDATO ESTADO1", nombreEstadoCand)
				} else setNombreEstadCand(true);
			}
			if (candidato.entidadFederativa) {
				let entidadCamp = entidades.find((entidad) => entidad.idEstado === candidato.entidadFederativa);
				if (entidadCamp) setNombreEstadoCamp(entidadCamp.nombreEstado.toLowerCase());
				else setNombreEstadoCamp(true);
			}
		}
	}, [candidato, entidades]);

	// -------------------- Ini codigo Leonardo ----------------------------
	// -------------------- cursos candidato ----------------------------
	useEffect(() => {
		if (cursosCandidatosSupremaCorte && idTipoCandidaturaB === 6) {
			let cursosCandidato = cursosCandidatosSupremaCorte.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosSupremaCorte]);

	useEffect(() => {
		if (cursosCandidatosSalaSuperior && idTipoCandidaturaB === 8) {
			let cursosCandidato = cursosCandidatosSalaSuperior.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosSalaSuperior]);

	useEffect(() => {
		if (cursosCandidatosTribunalDisciplina && idTipoCandidaturaB === 7) {
			let cursosCandidato = cursosCandidatosTribunalDisciplina.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosTribunalDisciplina]);

	useEffect(() => {
		if (cursosCandidatosSalaRegional && idTipoCandidaturaB === 9) {
			let cursosCandidato = cursosCandidatosSalaRegional.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosSalaRegional]);

	useEffect(() => {
		if (cursosCandidatosCircuito && idTipoCandidaturaB === 10) {
			let cursosCandidato = cursosCandidatosCircuito.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosCircuito]);

	useEffect(() => {
		if (cursosCandidatosJueces && idTipoCandidaturaB === 11) {
			let cursosCandidato = cursosCandidatosJueces.filter((curso) => curso.idCandidato === idCandidatoB);
			if (cursosCandidato) setCursosCandidato(cursosCandidato);
			else setCursosCandidato(true);
		}
	}, [cursosCandidatosJueces]);
	// -------------------- Fin codigo Leonardo ----------------------------

	const renderHipervinculos = (idTipoHiper) => {
		switch (idTipoHiper) {
			case 1:
				return <img key={`hiper-img-${idTipoHiper}`} className="img-responsive" alt="Únete a nuestra comunidad" src={Tipo1} />;
			case 4:
				return <img key={`hiper-img-${idTipoHiper}`} className="img-responsive" alt="Únete a nuestra comunidad" src={Tipo4} height="80px" />;
			case 5:
				return <img key={`hiper-img-${idTipoHiper}`} className="img-responsive" alt="Únete a nuestra comunidad" src={Tipo5} />;
			case 6:
				return <img key={`hiper-img-${idTipoHiper}`} className="img-responsive" alt="Únete a nuestra comunidad" src={Tipo6} />;
			case 7:
				return <img key={`hiper-img-${idTipoHiper}`} className="img-responsive" alt="Únete a nuestra comunidad" src={Tipo7} />;
			default:
				return <div key={`hiper-img-${idTipoHiper}`} style={{ minHeight: '80px' }}></div>;
		}
	};

	const buildHipervinculo = (hipervinculo) => {
		//console.log("hipervinculo", hipervinculo)
		switch (hipervinculo.idTipoHiper) {
			case 8:
				//  //console.log("hipervinculo", hipervinculo.hipervinculo);
				////console.log("hipervinculo1", `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, ""));
				return `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, '');
			case 7:
				////console.log("hipervinculo2", `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, ""));
				return `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, '');
			case 5:
				//  //console.log("hipervinculo3", `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, ""));
				return `${process.env.REACT_APP_API_URL}` + hipervinculo.hipervinculo.replace(`${process.env.REACT_APP_RUTA_ELIMINAR_HIPERVINCULOS}`, '');

			default:
				return hipervinculo.hipervinculo;
		}
	};

	const buildRutaFicha = (candidato) => {
		return (
			`${process.env.REACT_APP_API_URL}` +
			`${process.env.REACT_APP_RUTA_ARCHIVOS}` +
			candidato.nombreCandidato.replaceAll(' ', '_') +
			'_' +
			candidato.idCandidato +
			'.pdf'
		);
	};

	// const burcarAccionAfirmatibaDesc = (candidato) => {
	// 	if (candidato != null && candidato != undefined)
	// 		return accionesAfirmativas.find((item) => item.idAccionAfirmativa === candidato.candidaturaAccionAfirmativa);
	// 	else return '';
	// };

	return (
		<>
			<div className="container">
				<div className="clearfix ">&nbsp;</div>
				<div className="row">
					<div className=" col-xs-12 ">
						<div className="breadcrumb" style={{ backgroundColor: 'white' }}>
							<li>
								<Link title="Volver a la búsqueda." to="/">Volver a la búsqueda</Link>
							</li>
							<li>Elección Poder Judicial</li>
							<li>Conóceles</li>
							<li className="active" style={{color:'#06021D'}}>Ficha candidatura</li>
							<div className="divider"></div>
						</div>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="row">
					<Card className="cardResponsabilidadUTTyPDP">
						<Row>
							<Col>
								<span className="alineacion-justificada">
									<span style={{ fontSize: '16px' }}>
										{' '}
										{
											//<span className="negro2-mensaje-consulta"> es proporcionada de manera obligatoria</span>
										}
										La información fue proporcionada de forma obligatoria por las personas candidatas a juzgadoras que participan en el Proceso Electoral Extraordinario del Poder Judicial de la Federación, por lo tanto,
										<span className="negro2-mensaje-consulta"> el contenido es responsabilidad de las personas candidatas </span>
										El INE promueve su difusión para que la ciudadanía conozca mejor a las candidaturas y tenga elementos que le permitan emitir un voto informado.
									</span>
								</span>
							</Col>
						</Row>
					</Card>
				</div>
			</div>
			{candidato != null && candidato != undefined && !candidato && !srcFoto && !redesSocialesCandidato && !cursosCandidato && (
				<div id="imprimir" className="container candidatos">
					<div className="clearfix">&nbsp;</div>
					<div id="contenedor-cargando" className="col-xs-12 text-center">
						<Spin spinning={true} />
					</div>
				</div>
			)}
			{candidato != null && candidato != undefined && candidato && srcFoto && redesSocialesCandidato && cursosCandidato && (
				<>
					<div id="imprimir" className="container candidatos">
						<div className="clearfix">&nbsp;</div>
						<div className="contenedorPrincipal">
							{/* FICHA*/}
							
								<div className={`contenedorA col-xs-12 col-sm-12 col-md-4 col-lg-4 text-center ficha-card color-${idTipoCandidaturaB}`} >
									
									<div>
										<Avatar
											size={200}
											//style={{ border: '6px solid #b6b6b6' }}
											src={
												<img
													alt="Fotografía de la persona candidata"
													src={srcFoto}
													key="foto"
													onError={(e) => {
														if (candidato.sexo == 'M') e.target.src = Mujer;
														else e.target.src = Hombre;
													}}
												/>
											}
										/>
									</div>
									<div className="clearfix">&nbsp;</div>
									<div>
										<h2 className="nombre-candidato" data-det="nombreCandidato" style={{ marginTop: '25px', color: '#000000'}}>
											{candidato.nombreCandidato ? candidato.nombreCandidato : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
										</h2>
									</div>
									<div className="clearfix">&nbsp;</div>
									<div>
										<span style={{ marginTop: '25px', color: '#000000', fontSize: '12px', fontWeight: "bold"}}>
											{candidato.numListaBoleta ? "NÚMERO DE LISTA:" : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
										</span>
										<br/>
										<span className="nombre-candidato"  style={{ marginTop: '25px', color: '#000000', fontSize: '36px'}}>
											{candidato.numListaBoleta ? candidato.numListaBoleta : " "}
										</span>
									</div>
									<div style={{ marginTop: '10px'}}>
										<span className="lista-poderes" data-det="poderPostula" style={{ marginTop: '35px', fontSize: '12px', fontWeight: "bold" }}>
											{candidato.poderPostula ? `${process.env.REACT_APP_ETIQUETA_PODER_POSTULA}` : ''}
										</span>
									</div>

									<div class='contenedorPoderPostula'>
										{candidato.poderPostula.some(poder => poder === 1) && (
											<>
												<div class='col-xs-12 divPoderPostula' >
													<img
														alt="Imagen que representa al poder Ejectuvo Federal"
														src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PE.png`}
														key="emblema1"
														onError={(e) => { e.target.src = NoDisponible; }}
														style={{ width: '35px', marginTop: '-5px' }} />

													<span className="nombre-poderes" data-det="poderPostula">
														&nbsp;{process.env.REACT_APP_ETIQUETA_PE}
													</span>
												</div>
											</>
										)}

										{candidato.poderPostula.some(poder => poder === 2) && (
											<>
												<div class='col-md-12 divPoderPostula'>
													<img
														alt="Imagen que representa al poder Legislativo Federal"
														src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PL.png`}
														key="emblema2"
														onError={(e) => { e.target.src = NoDisponible; }}
														style={{ width: '35px', marginTop: '-5px' }}
													/>
													<span className="nombre-poderes" data-det="poderPostula">
														&nbsp;{process.env.REACT_APP_ETIQUETA_PL}
													</span>
												</div>
											</>
										)}

										{candidato.poderPostula.some(poder => poder === 3) && (
											<>
												<div class='col-xs-12 divPoderPostula'>
													<img
														alt="Imagen que representa al poder Judicial de la Federación"
														src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PJ.png`}
														key="emblema2"
														onError={(e) => { e.target.src = NoDisponible; }}
														style={{ width: '35px', marginTop: '-5px' }}
													/>
													<span className="nombre-poderes" data-det="poderPostula">
														&nbsp;{process.env.REACT_APP_ETIQUETA_PJ}
													</span>
												</div>
											</>
										)}

										{candidato.poderPostula.some(poder => poder === 4) && (
											<>
												<div class='col-xs-12 divPoderPostula'>
													<img
														alt="Imagen que representa al poder En funciones"
														src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/EF.png`}
														key="emblema2"
														onError={(e) => { e.target.src = NoDisponible; }}
														style={{ width: '35px', marginTop: '-5px' }}
													/>
													<span className="nombre-poderes" data-det="poderPostula">
														&nbsp;{process.env.REACT_APP_ETIQUETA_EF}
													</span>
												</div>
											</>
										)}
									</div>
								</div>
							
							<div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 border-left-separacion"
							style={{marginRight:"-5px", display:"flex", flex:"2", flexDirection:"column", alignItems:"stretch"}}>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">

											<h2>Datos generales</h2>
											<span>
												Los campos señalados con este símbolo&nbsp;
												<FaRegCheckCircle style={{ marginRight: "3px", color: "#d5007f", paddingTop: "1px" }} />
												fueron proporcionados por el Senado de la República.
											</span>
											<div className="clearfix">&nbsp;</div>
										</div>
										<div className="col-sm-6 col-md-6 col-lg-6">
											<div className="label-data propietario">
												<span><FaRegCheckCircle className='icono-check-circle' />Nombre:</span>
											</div>
											{candidato.tipoCandidato === 'P' ? (
												<div data-det="nombreCandidato" style={{ marginLeft: "20px" }}>
													{candidato.nombreCandidato ? candidato.nombreCandidato : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</div>
											) : candidato.tipoCandidato === 'S' ? (
												<div data-det="nombreCandidato" style={{ marginLeft: "20px" }}>
													{propietarioSuplente ? propietarioSuplente : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</div>
											) : (
												<div data-det="nombreCandidato" style={{ marginLeft: "20px" }}>
													{candidato.nombreSuplente ? candidato.nombreSuplente : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</div>
											)}
											<div className="clearfix">&nbsp;</div>
										</div>

										<div className="col-sm-6 col-md-6 col-lg-6">
											<div className="label-data">
											<span><FaRegCheckCircle className='icono-check-circle' />Cargo por el que participa:</span>
											</div>
											<div data-det="nombreCandidato" style={{ marginLeft: "20px" }}>
												{candidato.nombreCorto ? candidato.nombreCorto.toUpperCase() : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
											</div>
											<div className="clearfix">&nbsp;</div>
										</div>

										<div className="col-sm-6 col-md-6 col-lg-2">
											<div className="label-data">
											<span>{candidato.sexo ? <FaRegCheckCircle className='icono-check-circle' /> : ''}Sexo:</span>
											</div>
											<div data-det="sexo" style={{ marginLeft: "20px" }}>

												{candidato.sexo
													? candidato.sexo === 'H'
														? 'HOMBRE'
														: candidato.sexo === 'M'
															? 'MUJER'
															: `${process.env.REACT_APP_ETIQUETA_SENADO_NO_PROPORCIONO}`
													: `${process.env.REACT_APP_ETIQUETA_SENADO_NO_PROPORCIONO}`}
											</div>
											<div className="clearfix">&nbsp;</div>
										</div>

										{([6,7,8].includes(Number(idTipoCandidaturaB)) &&((candidato.idEstadoEleccion === null || candidato.idEstadoEleccion === 0))) && (
											<div className="col-sm-6 col-md-6 col-lg-4 ">

											</div>
										)}

										{
											([9].includes(Number(idTipoCandidaturaB)) &&((candidato.idCircunscripcionEleccion !== null || candidato.idCircunscripcionEleccion !== 0)) )&& (
											<div className="col-sm-6 col-md-6 col-lg-4 centerCirc">
												<div className="label-data">
												<span><FaRegCheckCircle className='icono-check-circle' />Circunscripción:</span>
												</div>
												<div data-det="nombreCandidato" style={{ marginLeft: "20px" }}>
													{candidato.idCircunscripcionEleccion ? candidato.idCircunscripcionEleccion : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</div>
												<div className="clearfix">&nbsp;</div>
											</div>
										)}

										{([10,11].includes(Number(idTipoCandidaturaB)) && ((candidato.idCircuito !== null && candidato.idCircuito !== 0))) && 
											(
												<div className="col-sm-6 col-md-6 col-lg-4 centerCirc">
													<div className="label-data">
													<span><FaRegCheckCircle className='icono-check-circle' />Circuito Judicial:</span>
													</div>
													<div data-det="nombreEstado" style={{ marginLeft: "20px" }}>
														{candidato.idCircuito ? candidato.idCircuito : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
													</div>
													<div className="clearfix">&nbsp;</div>
												</div>
											)
										}

										{([10,11].includes(Number(idTipoCandidaturaB)) && ((candidato.idDistritoJudicial !== null && candidato.idDistritoJudicial !== 0))) && 
											(
												<div className="col-sm-6 col-md-6 col-lg-4 ">
													<div className="label-data">
														<span><FaRegCheckCircle className='icono-check-circle' />Distrito Judicial:</span>
													</div>
													<div data-det="nombreEstado" style={{ marginLeft: "20px" }}>
														{candidato.idDistritoJudicial ? candidato.idDistritoJudicial : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
													</div>
													<div className="clearfix">&nbsp;</div>
												</div>
											)
										}

										{([10,11].includes(Number(idTipoCandidaturaB)) && ((candidato.especialidad !== null && candidato.especialidad !== 0))) && 
											(
												<div className="col-sm-6 col-md-6 col-lg-6 ">
													<div className="label-data">
														<span><FaRegCheckCircle className='icono-check-circle' />Especialidad:</span>
													</div>
													<div data-det="nombreEstado" style={{ marginLeft: "20px" }}>
														{candidato.especialidad ? candidato.especialidad : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
													</div>
													<div className="clearfix">&nbsp;</div>
												</div>
											)
										}

										{(candidato.numListaBoleta) && (
											<div className="col-sm-6 col-md-6 col-lg-5">
												<div className="label-data">
													<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Número de lista en la boleta:</span>
												</div>
												<div data-det="numListaBoleta">
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
													{candidato.numListaBoleta ? candidato.numListaBoleta : ''}
												</div>
											</div>
										)}

									</div>
								</Card>
								{candidato && candidato.estatusVal == 1 ? (
									<><div className="clearfix">&nbsp;</div><Card className="cardSeccion" >
										<div className="row">
											<div className="col-lg-12">
												<div>
													<h2> Medios de contacto</h2>
													<span> &nbsp; </span>
												</div>
											</div>
											<div className="col-lg-9" style={{ width: '73%' }}>
												<div className="row">
												
													<div className="col-sm-6 col-md-6 col-lg-6">
														{!candidato.telefonoPublico2 || !candidato.telefonoPublico3 ? (
															<div className="label-data"><span>Teléfono público:</span> </div>
														) : (
															candidato.telefonoPublico &&
															(candidato.telefonoPublico2 || candidato.telefonoPublico3) && (
																<div className="label-data"><span>Teléfonos públicos:</span> </div>
															)
														)}
														<div>
															{/*<span className="lada" data-det="lada">{candidato.telefonoPublico && candidato.lada ? <>{candidato.lada}&nbsp;</> : ""}</span>*/}

															<span data-det="telefonoPublico">
																{candidato.telefonoPublico
																	? candidato.telefonoPublico
																	: `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
															</span>
															{candidato.telefonoPublico2 ? (
																<>
																	<br /> <span data-det="telefonoPublico">{candidato.telefonoPublico2}</span>
																</>
															) : (
																''
															)}
															{candidato.telefonoPublico3 ? (
																<>
																	<br /> <span data-det="telefonoPublico">{candidato.telefonoPublico3}</span>
																</>
															) : (
																''
															)}
														</div>
														<div className="clearfix">&nbsp;</div>
													</div>
													<div className="col-sm-6 col-md-6 col-lg-6">
														<div className="label-data"><span>Página web:</span> </div>
														<div>
															<span data-det="correoElecPublico">
																{candidato.paginaWeb ? (
																	<a target="_blank" title="Página web proporcionada por la persona candidata." href={candidato.paginaWeb} style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
																		{candidato.paginaWeb} 
																	</a>
																) : (
																	`${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`
																)}
															</span>
														</div>
														<div className="clearfix">&nbsp;</div>
													</div>
													<div className="col-sm-6 col-md-6 col-lg-6">
														<div className="label-data"><span>Correo electrónico público:</span> </div>
														<div>
															<span data-det="correoElecPublico" style={{ wordBreak: 'break-all' }}>
																{candidato.correoElecPublico
																	? candidato.correoElecPublico
																	: `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
															</span>
														</div>
														<div className="clearfix">&nbsp;</div>
													</div>

												</div>
											</div>
											<div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
												<div className="row">
													<div className="col-xs-12">
														<div className="label-data"><span>Redes sociales:</span> </div>
													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-12">
														{redesSocialesCandidato.length ? (
															<div className="row" style={{ width: '200px' }}>
																{redesSocialesCandidato.map((element) => {
																	if (element.idTipoRed === 1)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																				<a key="facebook" title="Link de Facebook proporcionada por la persona candidata." href={element.descripcionRed} target="_blank">
																					<img
																						alt="Ir a la página de Facebook"
																						className="icono-red"
																						style={{ width: '26px', height: '26px', marginTop: '2px' }}
																						src={logoFacebook} />
																				</a>
																		
																			</div>
																		);
																	if (element.idTipoRed === 2)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																				<a key="x" href={element.descripcionRed} target="_blank" title="Link de X proporcionada por la persona candidata.">
																					<img
																						alt="Ir a la página de X"
																						className="icono-red"
																						style={{ width: '26px', height: '26px', marginTop: '1px' }}
																						src={xlogo} />
																				</a>
																			</div>
																		);
																	if (element.idTipoRed === 3)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																			
																				<a key="instagram" href={element.descripcionRed} target="_blank" title="Link de Instagram proporcionada por la persona candidata.">
																					<img
																						alt="Ir a la página de Instagram"
																						className="icono-red"
																						style={{ width: '26px', height: '26px', marginTop: '2px' }}
																						src={logoIntagram} />
																				</a>
																			</div>
																		);
																	if (element.idTipoRed === 4)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																			
																				<a key="youtube" href={element.descripcionRed} target="_blank" title="Link de Youtube proporcionada por la persona candidata.">
																					<img
																						alt="Ir a la página de Youtube"
																						className="icono-red"
																						style={{ width: '26px', height: '26px', marginTop: '2px' }}
																						src={logoYoutube} />
																				</a>
																			</div>
																		);
																	if (element.idTipoRed === 5)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																				<a key="tiktok" href={element.descripcionRed} target="_blank"title="Link de Tiktok proporcionada por la persona candidata.">
																					<img
																						alt="Ir a la página de Tiktok"
																						className="icono-red"
																						style={{ width: '24px', height: '24px', marginTop: '3px' }}
																						src={tiktok} />
																				</a>
																			</div>
																		);
																	if (element.idTipoRed === 6)
																		return (
																			<div className="col-xs-3" style={{ paddingBottom: '5px' }}>
																			
																				<a key="otraRed" href={element.descripcionRed} target="_blank"title="Link de otra red social proporcionada por la persona candidata.">
																					<img
																						alt="Ir a la página de otra red social"
																						className="icono-red"
																						style={{ width: '26px', height: '26px', marginTop: '2px' }}
																						src={logoOtraRed} />
																				</a>
																			</div>
																		);
																})}
															</div>
														) : (
															<span data-det="redesSociales">La candidatura no proporcionó información</span>
														)}
														<div className="clearfix">&nbsp;</div>
													</div>
												</div>
											</div>
										</div>
									</Card></>
								) : <>
								<div className='col-xs-12 col-md-12 divSeccionSinInfo' style={{marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
									<div className='seccionSinInfo'>
										<img
											src={imgLaptop}
											key="laptop"
											onError={(e) => { e.target.src = NoDisponible; }}
											style={{ width: '60px' }}
										/>
										<br></br>
										La persona candidata no proporcionó información
									</div>
								</div>
							</>
								}
							</div>
						</div>
					</div>

					<div id="imprimir" className="container candidatos" style={{marginTop:'25px'}}>
						
						{candidato && candidato.estatusVal == 1 ? (
							<div>
								<Card className="cardSeccionBlack">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="tituloBlack">¿Por qué quiero ocupar un cargo público?</h2>
											</div>
										</div>
										<div className="col-lg-12">
											<span className="contenidoBlack">
												{candidato.descripcionCandidato
													? candidato.descripcionCandidato
													: `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
											</span>
										</div>
									</div>
								</Card>
								<div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="gris-ficha" style={{color: "#000000"}}>
													Visión de la función jurisdiccional
												</h2>
											</div>
										</div>
										<div className="col-lg-12">
											<span className="ajustar">{candidato.visionJurisdiccional ? candidato.visionJurisdiccional : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}</span>
										</div>
									</div>
								</Card>
								<div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="gris-ficha" style={{color: "#000000"}}>
													Visión de la impartición de justicia
												</h2>
											</div>
										</div>
										<div className="col-lg-12">
											<span className="ajustar">{candidato.visionImparticionJusticia ? candidato.visionImparticionJusticia : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}</span>
										</div>
									</div>
								</Card>
								<div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="gris-ficha" style={{color: "#000000"}}>Principales propuestas</h2>
												<span>&nbsp;</span>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="label-data"><h3>Propuesta 1:</h3> </div>
											<div>
												<span className="ajustar">
													{candidato.propuesta1 ? candidato.propuesta1 : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</span>
											</div>
										</div>
										<div className="col-lg-12">
											<br></br>
											<div className="label-data"><h3>Propuesta 2:</h3> </div>
											<div>
												<span className="ajustar">
													{candidato.propuesta2 ? candidato.propuesta2 : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</span>
											</div>
										</div>
										<div className="col-lg-12">
											<br></br>
											<div className="label-data"><h3>Propuesta 3:</h3> </div>
											<div>
												<span className="ajustar">
													{candidato.propuesta3 ? candidato.propuesta3 : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</span>
											</div>
										</div>
									</div>
								</Card>
								<div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="gris-ficha" style={{color: "#000000"}}>
													Curriculum vitae
												</h2>
											</div>
										</div>
										<div className="col-lg-12">
											<span className="info">
												<FaSearch style={{ marginRight: "3px" }} />
												<a className="info1" href="#" title="Documento PDF: Curriculum vitae de la persona candidata." onClick={(event) => openModal(event, candidato.idCandidato)}>
													Visualiza el Curriculum Vitae de la persona candidata.
												</a>
												&nbsp;
											</span>
											<PdfViewerModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} pdfUrl={pdfUrl} />
										</div>
									</div>
								</Card>
								<div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion"> {/* {`info-card  color-${idTipoCandidaturaB}`} */}
									<div className="row">
										<div className="col-lg-12">
											<div>
												<h2 className="gris-ficha" style={{color: "#000000"}}>
													Trayectoria académica
												</h2>
											</div>
										</div>
										<div className="col-lg-12 ">
											<span className="ajustar">
												{candidato.descripcionTP ? candidato.descripcionTP : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
											</span>
										</div>
									</div>
								</Card>
								{/* <div className="clearfix">&nbsp;</div>
								<Card className="cardSeccion">
									<div className="row">
										<div className="col-lg-12">
											<div>
												<span className="gris-ficha">Historia profesional y/o laboral</span>
											</div>
										</div>
										<div className="col-lg-12">
											<span className="ajustar">
												{candidato.descripcionHLC ? candidato.descripcionHLC : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
											</span>
										</div>
									</div>
								</Card> */}
								<div className="clearfix">&nbsp;</div>
								<Row gutter={[16, 16]}>
									<Col xs={{ span: 24 }} lg={{ span: 24 }}>
										<Card className="cardSeccionBlack">
											<div>
												<h2 className="tituloBlack">Estudios</h2>
											</div>
											<div>
												<span className="contenidoBlack">
													<b>Grado máximo de estudios:</b>{' '}
													{candidato.idGrado && grado ? grado.descripcionGrado : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</span>
											</div>
											<div>
												<span className="contenidoBlack">
													<b>Estatus:</b>{' '}
													{candidato.idGrado && grado ? grado.estatus : `${process.env.REACT_APP_ETIQUETA_SIN_REGISTRO}`}
												</span>
											</div>
										</Card>
									</Col>
								</Row>
								<div className="clearfix">&nbsp;</div>
								<Row gutter={[16, 16]}>
									<Col xs={{ span: 24 }} lg={{ span: 24 }}>
										<Card className="cardSeccionBlack">
											<div>
												<h2 className="tituloBlack">Cursos, diplomados, seminarios, especializaciones</h2>
											</div>
											<div>
												{cursosCandidato.length > 0 ? (
													<>
														{cursosCandidato.length == 1 ? (
															<span className="contenidoBlack">{cursosCandidato[0].descripcion}</span>
														) : (
															<>
																<ol id={`curso-${cursosCandidato[0]}`} className="contenidoBlack">
																	{cursosCandidato.map((item) => {
																		return <li>{item.descripcion}</li>;
																	})}
																</ol>
															</>
														)}
													</>
												) : (
													<span className="contenidoBlack">La candidatura no proporcionó información</span>
												)}
											</div>
										</Card>
									</Col>
								</Row>
							</div>
						) :
							''
						}
						<div className="clearfix">&nbsp;</div>
						{/*hipervinculosCandidato.length > 0 && (
							<Card className="cardSeccion">
								<Row gutter={[16, 16]}>
									<Col xs={{span: 24}} lg={{span: 24}}>
										<span className="gris-ficha">Consulta los sitios de interés con información relacionada de las y los candidatos</span>
									</Col>
									{hipervinculosCandidato.map((item) => {
										return (
											<Col
												key={`col-hiper-${item.idTipoHiper}`}
												xs={{span: 24}}
												sm={{span: 12}}
												md={{span: 8}}
												lg={{span: 8}}
												className="text-center hiperviculuos-link"
											>
												<a key={`hiper-a-${item.idTipoHiper}`} href={buildHipervinculo(item)} target="_blank">
													<div className="container-hipervinculos">{renderHipervinculos(item.idTipoHiper)}</div>
													<div style={{paddingTop: '10px'}}>{item.descripcionHiper}</div>
												</a>
											</Col>
										);
									})}
								</Row>
							</Card>
						)*/}
						{/*<div className="clearfix ">&nbsp;</div>
                        <div className="row">
                            <div className="col-xs-12 text-left">
                                <span className="genero-informa">
                                    Fecha de actualización: Candidaturas vigentes al {dia} de {meses[mes]} de {anio} INE/CG337/2021.
                                </span>
                            </div>
            			      </div>*/}
						<div className="clearfix">&nbsp;</div>
						<Row>
							<Col xs={{ span: 12 }}>
								<div style={{ display: 'flex', justifyContent: 'flex-start' }}>
									<Link
										to={{
											pathname: '/',
											state: { regresar: regresar },
										}}
									>
										<Button key="regresar" type="primary" className="secondary-button">
											Regresar
										</Button>
									</Link>
								</div>
							</Col>
							{(candidato && (candidato.estatusVal == 1 || candidato.validaCuestionario == 1)) ||
								(hipervinculosCandidato && hipervinculosCandidato.length > 0) ? (
								<Col xs={{ span: 12 }}>
									<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
										<Button key="buscar" type="link" className="primary-button" target="_blank" href={buildRutaFicha(candidato)}>
											<DownloadOutlined />
											Descargar
										</Button>
									</div>
								</Col>
							) : (
								<></>
							)}
						</Row>
					</div>
				</>
			)}
			{candidato === null ||
				(candidato === undefined && (
					<>
					<div className='col-xs-2 col-md-2'></div>
					<div className='col-xs-8 col-md-8 divSeccionSinInfo' style={{marginTop: '35px', paddingLeft: '0px', paddingRight: '0px' }}>
									<div className='seccionSinInfo'>
										<img
											src={imgLaptop}
											key="laptop"
											onError={(e) => { e.target.src = NoDisponible; }}
											style={{ width: '60px' }}
										/>
										<br></br>
										La persona candidata no proporcionó información
									</div>
								</div>
								<div className='col-xs-12 col-md-12'></div>
								<br></br>
								<br></br>

						<Row style={{ padding: '50px', paddingLeft: '200px' }}>
							<Col>
								<div style={{ display: 'flex', justifyContent: 'flex-start' }}>
									<Link
										to={{
											pathname: '/',
											state: { regresar: regresar },
										}}
									>
										<Button key="regresar" type="primary" className="secondary-button">
											Regresar
										</Button>
									</Link>
								</div>
							</Col>
							<Col style={{ paddingLeft: '300px' }}>
							
							</Col>
						</Row>
					</>
				))}

				<br/>
				<br/>

				{/*<Row className={`shadow-card color-${idTipoCandidaturaB}`}>
					<Col className="custom-colx">
						<Row>
							<Col xs={24} sm={24} md={24} lg={6} xl={6}>
								<Row>
									<Col>
										<Avatar
											size={200}
											src={
												<img
													src={srcFoto}
													key="foto"
													onError={(e) => {
														if (candidato.sexo == 'M') e.target.src = Mujer;
														else e.target.src = Hombre;
													}}
												/>
											}
										/>
									</Col>
								</Row>
								<Row style={{marginTop:"15px"}}>
									<Col style={{fontWeight:"bold"}}>
										POSTULADA/O POR:
									</Col>
									<Col>
										{poderesfichaDos}
									</Col>
								</Row>
							</Col>
							<Col xs={24} sm={24} md={24} lg={18} xl={18}>
							</Col>
						</Row>
						<Row style={{display: "flex", alignContent:"center", justifyContent:"center", textAlign:"center", marginTop:"20px"}}>
							<Col style={{display: "flex", alignContent:"center", justifyContent:"center", textAlign:"center"}}>
								
									Los campos señalados con este símbolo&nbsp;
								
									<FaRegCheckCircle style={{ marginRight: "3px", color: "#d5007f", paddingTop: "1px" }} />
								
									fueron proporcionados por el Senado de la República.
								
							</Col>
						</Row>
					</Col>
				</Row> */}

				<br/>
				<br/>
				<br/>
			<div className="clearfix">&nbsp;</div>
			<div className="clearfix">&nbsp;</div>
		</>
	);
};

export default DetalleCandidato;
